export function stringDateComparator(value1: string, value2: string): number {
  const date1 = Date.parse(value1);
  const date2 = Date.parse(value2);

  if (date1 > date2) {
    return 1;
  }
  if (date1 < date2) {
    return -1;
  }
  return 0;
}

export function stringComparator(value1: string, value2: string): number {
  const val1 = value1 || '';
  const val2 = value2 || '';
  return val1.localeCompare(val2, 'da', { sensitivity: 'base' });
}

export function numberComparator(value1: number, value2: number): number {
  const val1 = value1 ?? 0;
  const val2 = value2 ?? 0;

  if (val1 > val2) {
    return 1;
  }
  if (val1 < val2) {
    return -1;
  }
  return 0;
}
